import { useQuery } from '@tanstack/react-query';

import { authApi } from '../api/auth-api';

import { authKeys } from './auth-keys';

/** Public: which sign-in methods the platform has configured. Changes only on a redeploy. */
export function useSignInProviders() {
  return useQuery({
    queryKey: authKeys.providers(),
    queryFn: () => authApi.providers(),
    staleTime: 60 * 60_000,
    meta: { silentError: true },
  });
}
